import { Expression } from '../builder/expression';
import { Constant } from '../builder/utilities';

export const startsWith = (
  target: string | Expression | null,
  matcher: string | Expression | null,
  opts?: { jsStackPointer?: Function }
): Expression =>
  Expression.wrap(target, { ty: 'string' }).like(
    Expression.wrap(matcher, { ty: 'string' }).concat('%'),
    {
      jsStackPointer: opts?.jsStackPointer ?? startsWith,
    }
  );

export const endsWith = (
  target: string | Expression | null,
  matcher: string | Expression | null,
  opts?: { jsStackPointer?: Function }
): Expression =>
  Expression.wrap(target, { ty: 'string' }).like(
    Constant('%').concat(Expression.wrap(matcher, { ty: 'string' })),
    {
      jsStackPointer: opts?.jsStackPointer ?? startsWith,
    }
  );
